import MDTypography from 'components/MDTypography';

export const ProgressTabLabelValue = ({ label, value }) => {
  return (
    <>
      <MDTypography
        variant="body2"
        component="span"
        fontWeight="bold"
        textTransform="capitalize"
      >
        {label}:
      </MDTypography>
      <MDTypography
        color="text"
        variant="body2"
        component="span"
        fontWeight="regular"
      >
        {value || '-'}
      </MDTypography>
    </>
  );
};

export const calculateAverageGrade = (studentData) => {
  if (!studentData || studentData?.length === 0) return 0;

  const totalCourses = studentData?.length;
  const sum = studentData?.reduce((total, item) => {
    return total + (parseFloat(item?.actualgrade) || 0);
  }, 0);

  return (sum / totalCourses).toFixed(1);
};

export const calculateAverageCompletion = (studentData) => {
  if (!studentData || studentData?.length === 0) return 0;

  const totalCourses = studentData?.length;
  const sum = studentData?.reduce((total, item) => {
    return total + (parseFloat(item?.percentbycount) || 0);
  }, 0);

  return (sum / totalCourses).toFixed(2);
};
